import { Lesson } from '@/app/entities/Training'
import { useLessonList } from '../providers/LessonListProvider'

import { cn } from '@/app/utils/cn'
import { withCdn } from '@/app/utils/withCdn'

interface ViewLessonsProps {
  onLessonChange: (lesson: Lesson) => void
  lessons: Lesson[]
}

export function ViewLessons({ onLessonChange, lessons }: ViewLessonsProps) {
  const { currentLesson } = useLessonList()

  const isSelected = (lesson: Lesson) => {
    return currentLesson?._id === lesson._id
  }

  return (
    <div className="flex flex-col divide-y rounded-b-2xl border border-t-0">
      {lessons.map((lesson) => (
        <div
          onClick={() => onLessonChange(lesson)}
          key={lesson._id}
          className={cn(
            'flex cursor-pointer items-center gap-5 p-4 text-xl font-semibold ',
            isSelected(lesson) && 'bg-gray-100',
          )}
        >
          {lesson.thumbnail && (
            <img
              src={withCdn(lesson.thumbnail)}
              alt={lesson?.name}
              className={cn('h-[61px] w-[125px] rounded-md bg-gray-200')}
            />
          )}
          <h1>{lesson.name}</h1>
        </div>
      ))}
    </div>
  )
}
